module.exports = __webpack_public_path__ + "img/user1.bdac7a9e.png";